import { NamedWidget, NamedWidgetProps } from 'lib-node-amb-renderer';

import { DocumentTypes } from '~/pages/IncomeCalculator/enums';

type DocumentOptions = {
  id?: number | string;
  label?: string;
};

export interface PDFViewerProps extends NamedWidgetProps {
  defaultDocument?: number;
  documentOptions?: Array<DocumentOptions>;
}

export class PDFViewerWithIframeClass extends NamedWidget {
  defaultDocument;
  documentOptions;
  constructor(props: PDFViewerProps) {
    super(props);
    this.defaultDocument = props.defaultDocumentId;
    this.documentOptions = props.documentOptions;
  }

  execute(data: any, props?: object) {
    this.documentOptions = data?.documentOptions || [];
    return super.execute(data, props);
  }
}

export const documentTypesToResetCitation: Set<string> = new Set([
  String(DocumentTypes.W2),
]);
